(function () {
  // Out-of-stock "size" button options are visually rendered but the theme's CSS
  // (theme.css: ".size.product-form__input .non-existent.disabled.existent + .product-form__input-label")
  // sets pointer-events: none on their label once a color is chosen, so a real mouse
  // click never reaches the radio input (this only blocks NATIVE clicks; the input has
  // no `disabled` attribute, so it CAN still be checked programmatically). For the
  // back-in-stock flow, customers need to be able to actually click and pick the size
  // they want restocked, so we re-enable pointer events for that specific state.
  var style = document.createElement('style');
  style.textContent =
    '.product-form__input.size .product-form__input-option.disabled.non-existent.existent + .product-form__input-label { pointer-events: auto !important; cursor: pointer !important; }';
  document.head.appendChild(style);
})();

(function () {
  // Auto-select any option that only has a single value (e.g. a single "FREE" size),
  // so back-in-stock signups are tied to a real variant even if the shopper never
  // clicks a lone/only option. Runs whenever the variant fieldsets are (re)rendered.
  function autoSelectSingleOptions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var fieldsets = scope.querySelectorAll('[data-fieldset]');
    fieldsets.forEach(function (fieldset) {
      var inputs = fieldset.querySelectorAll('input[type="radio"][data-option-value-id]');
      if (inputs.length !== 1) return;
      var onlyInput = inputs[0];
      if (onlyInput.checked) return;
      onlyInput.checked = true;
      onlyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function getSelectedVariantText() {
    var seen = {};
    var parts = [];
    document.querySelectorAll('[data-fieldset]').forEach(function (fieldset) {
      var key = fieldset.getAttribute('data-field-option') || fieldset.id;
      if (!key || seen[key]) return;
      var inputs = fieldset.querySelectorAll('input[type="radio"][data-option-value-id]');
      var checked = fieldset.querySelector('input[type="radio"]:checked, select option:checked');
      // Fall back to the single available value even if it never got a native "checked" state.
      if (!checked && inputs.length === 1) checked = inputs[0];
      if (checked && checked.value) {
        seen[key] = true;
        parts.push(checked.value);
      }
    });
    return parts.join(' / ');
  }

  function fillPlaceholder(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    var toUpdate = [];
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf('{{selected_variant}}') !== -1) {
        toUpdate.push(node);
      }
    }
    if (toUpdate.length === 0) return;
    autoSelectSingleOptions(document);
    var text = getSelectedVariantText();
    toUpdate.forEach(function (n) {
      n.nodeValue = text
        ? n.nodeValue.replace('{{selected_variant}}', text)
        : n.nodeValue.replace('{{selected_variant}}', 'this item');
    });
  }

  var bisObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        fillPlaceholder(n);
      });
    });
  });

  bisObserver.observe(document.documentElement, { childList: true, subtree: true });

  // Also run once on load and whenever a variant option changes, so single-value
  // options (like a lone "FREE" size) get selected as soon as possible rather than
  // only at the moment the Notify Me popup happens to open.
  document.addEventListener('DOMContentLoaded', function () {
    autoSelectSingleOptions(document);
  });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-fieldset]')) {
      setTimeout(function () {
        autoSelectSingleOptions(document);
      }, 50);
    }
  });
})();
